import { MotifErrorMessage, MotifIcon, MotifInput } from "@ey-xd/motif-react";
import React, { useState } from "react";
import { Control, Controller, useController } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  MotifActionIcVisibilityOff24px,
  MotifActionIcVisibility24px,
} from "@ey-xd/motif-icon";
import "./PrivacyMaskedInput.scss";
type ControlInputBoxType = {
  required?: boolean;
  control: Control<any>;
  name: string;
  documentTypeName: string;
  showLabel: boolean;
  label: string;
  prefix?: boolean;
  prefixComponent?: JSX.Element;
  withCountry?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  maxLength?: string;
  type?: "number" | "text" | "email" | "tel" | "date" | "password" | undefined;
  fieldArrayIndex: number;
  fieldArrayKey: string;
};
const PrivacyMaskedInput = ({
  name,
  control,
  required,
  showLabel,
  label,
  documentTypeName,
  fieldArrayIndex,
  fieldArrayKey,
}: ControlInputBoxType) => {
  const { field: documentType } = useController({
    //@ts-ignore
    name: documentTypeName,
    control,
  });
  required = documentType?.value ? true : false;

 const { field ,formState} = useController({
     //@ts-ignore
     name,
     control,
     rules: { required: required},
   });
  

  let errors: any = formState.errors;
  console.log("error", errors);
  const { t } = useTranslation();
  const [toogleInputType, setToogleInputType] = useState(false);
  function checkSpecialCharactersAccornce(value: any) {
    let flag = false;
    let specialCharacterOccurance = "";
    for (var i = 0; i < value.length; i = i + 4) {
      if (i < 3) {
        if (value[i + 3] !== " " && value[i + 3] !== "-") {
          flag = true;
          break;
        }
        specialCharacterOccurance = value[i + 3];
      } else if (i > 3) {
        if (
          value?.[i + 3] !== specialCharacterOccurance &&
          value[i + 3] !== undefined
        ) {
          flag = true;
          break;
        }
      }
      let partOfString = value.substring(i, i + 3);
      if (partOfString.includes(" ") || partOfString.includes("-")) {
        flag = true;
      }
    }
    return flag;
  }
  function sinNumberValidation(value: any) {
    //A valid Canada SIN is a 9-digit number
    let removespacesanddashes = value?.replace(/[- ]/g, "");
    if (removespacesanddashes?.length !== 9) return false;
    if (
      value?.[value.length - 1] === " " ||
      value?.[value.length - 1] === "-"
    ) {
      return false;
    }
    if (value?.includes("-") || value?.includes(" ")) {
      if (checkSpecialCharactersAccornce(value)) {
        return false;
      }
    }

    // accept only digits, dashes or spaces
    if (/[^0-9-\s]+/.test(value)) return false;

    // The Luhn Algorithm.
    let nCheck = 0;
    let nDigit = 0;
    let bEven = false;
    value = value?.replace(/\D/g, "");

    for (let n = value.length - 1; n >= 0; n--) {
      let cDigit = value.charAt(n);
      nDigit = parseInt(cDigit, 10);
      if (bEven) {
        if ((nDigit *= 2) > 9) nDigit -= 9;
      }

      nCheck += nDigit;
      bEven = !bEven;
    }

    return nCheck % 10 === 0;
  }
  return (
    <>
      {showLabel && (
        <div className="formFieldLabel">
          <label htmlFor="input" aria-label={label}>
            {t(label)}
            {required ? <span className="requiredSymbol">*</span> : ""}
          </label>
        </div>
      )}

      <div className="form-field privateUnmaskedFiledscon">
        <Controller
          name={field.name}
          control={control}
          rules={{ required: required }}
          render={({ field: { onChange, value, ...args } }) => {
            return (
              <>
                {/*@ts-ignore*/}
                <MotifInput
                  {...args}
                  id={name}
                  type={toogleInputType ? "text" : "password"}
                  hideClearButton={true}
                  value={value || ""}
                  onChange={(e) => {
                    onChange(e.target.value);

                  }}
                  maxLength={"100"}
                  className={"privateUnmaskedFiledsinput"}
                />
                {documentType?.value === 8 &&
                  !sinNumberValidation(value?.toString()) &&
                  value && (
                    <MotifErrorMessage>
                      {t(
                        "pages.creditors.creditorForm.formLabelDetails.requiredFieldsMessages.sinNumberValid",
                        { filedName: t(label) }
                      )}
                    </MotifErrorMessage>
                  )}
                {errors &&
                  errors?.fieldArray &&
                  errors?.fieldArray?.[fieldArrayIndex]?.[fieldArrayKey]
                    ?.type === "required" && (
                    <MotifErrorMessage>
                      {t(
                        "pages.creditors.creditorForm.formLabelDetails.requiredFieldsMessages.documnetIdRequired",
                        { filedName: t(label) }
                      )}
                    </MotifErrorMessage>
                  )}
              </>
            );
          }}
        />
        <div
          className="privateUnmaskedFiledsEye"
          onClick={() => setToogleInputType(!toogleInputType)}
        >
          <MotifIcon
            src={
              toogleInputType
                ? MotifActionIcVisibility24px
                : MotifActionIcVisibilityOff24px
            }
          ></MotifIcon>
        </div>
      </div>
    </>
  );
};

export default PrivacyMaskedInput;
